import { Controller } from 'stimulus'
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ['localities'];

  connect() {
    const that = this
    const element = document.querySelector('#linkedItems')
    element.addEventListener('blur', this.updateSuggestions)
    if (!this.choices) {
      this.choices = new Choices(element, {
        searchResultLimit: 1000,
        shouldSort: false
      })
      this.choices.passedElement.element.addEventListener(
        'search',
        function(event) {
          that.reloadOptions(event.detail.value)
        },
        false
      )
    }
  }

  reloadOptions(query) {
    const intl_scope = this.localitiesTarget.value
    Rails.ajax({
      type: 'get',
      url: '/linked_items/search',
      data: `query_string=${query}&intl_scope=${intl_scope}`,
      success: (data) => { this.choices.setChoices(data, 'id', 'label', true) }
    })
  }
}
